export default function () {
  return {
    page: {
      id: null
    }
  }
}
